import { Block, PrensaEngine } from '@xprog/prensa'
import React from 'react'

import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import styles from './custom-calendar.module.css'
import { DatePickerProps } from './DatePicker.types'

const Label = PrensaEngine.styled('label', {})

const StyledCalendar = PrensaEngine.styled(Calendar, {
  border: '1px solid rgb(230, 230, 230)',
  borderRadius: '12px',
  fontFamily: '$primary', // <- aqui é uma variável do theme
  padding: '12px',
  backgroundColor: '#fff',
  marginTop: '$4',

  '& .react-calendar__navigation__label': {
    width: '100%',
    textTransform: 'capitalize',
  },

  '& .react-calendar__tile--active': {
    backgroundColor: '$primaryMain', // <- variável do seu theme
    color: '#fff',
  },

  '& .react-calendar__tile--now': {
    backgroundColor: '$backgroundMain',
    color: '#000',
  },

  '& .react-calendar__tile:hover': {
    backgroundColor: '$primaryMain',
    color: '#fff',
  },

  '& .react-calendar__tile': {
    borderRadius: '8px',
  },

  '& .react-calendar__month-view__days__day--weekend': {
    color: '#000',
  },

  '& .react-calendar__month-view__days__day--neighboringMonth': {
    color: '#757575',
  },
  // Outras customizações...
})


const DatePicker: React.FC<DatePickerProps> = ({ css, ...otherProps }) => {

  return (
    <Block
      css={css?.container}
    >
      <Label
        css={{
          fontFamily: '$primary',
          fontSize: '16px',
          fontWeight: '500',
          ml: '$3',
          ...css?.label
        }}
      >
        Por data:
      </Label>

      <Block css={{ maxWidth: '280px' }}>
        <StyledCalendar
          onChange={(value) => {
            if (value instanceof Date) {
              otherProps.onChange?.(value)
            }
          }}
          value={otherProps.selectedDate || new Date(Date.now())}

        />

      </Block>
    </Block>
  )
}

export default DatePicker